<script>
import Vue from 'vue';
import debounce from 'lodash/debounce';
import { mapState, mapMutations, mapActions } from 'vuex';
import { Message, Input } from 'element-ui';

Vue.use(Input);

export default {
    name: 'oembed-input',

    props: {
        type: {
            type: [String, Boolean],
            default: 'input'
        },

        name: {
            type: String,
            default: null
        },

        value: {
            type: String,
            default: null
        },

        placeholder: {
            type: String,
            default: null
        },

        inputClass: {
            type: String,
            default: null
        },

        oembedOverride: {
            type: Boolean,
            default: false
        },

        reloadOnMount: {
            type: Boolean,
            default: true
        },

        visible: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState('oembed', [
            'url',
            'videoData'
        ]),

        inputUrl: {
            get() {
                return this.url;
            },

            set(val) {
                this.updateUrl(val);
            }
        }
    },

    mounted() {
        if (this.reloadOnMount) {
            this.updatePreview();
        }
    },

    methods: {
        ...mapMutations('oembed', [
            'updateUrl',
            'resetVideoData',
            'updateVideoData'
        ]),

        ...mapActions('oembed', [
            'getVideo'
        ]),

        getOembedData() {
            this.getVideo({
                url: this.inputUrl
            }).then(response => {
                response = Array.isArray(response) ? response[0] : response;
                
                if (response.code) {
                    this.$emit('loaded', response);
                } else {
                    if (this.oembedOverride) {
                        Message.warning("We couldn't find a thumbnail for your video. Please upload a custom thumbnail.");
                        this.$emit('loaded-without-oembed', response);
                    } else {
                        Message.error("The url you entered doesn't link to a video. Please enter a different url.");
                    }
                }
            })
        },

        onInput(val) {
            this.videoData.code = '';
            this.updatePreview();
            this.$emit('input', val);
        },

        updatePreview() {
            this.resetVideoData();
            this.addPreview();
        },

        addPreview: debounce(function() {
            if (this.inputUrl) {
                this.getOembedData();
            }
        }, 300)
    }
};
</script>

<template>
    <el-input
        v-show="visible"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        v-model="inputUrl"
        :class="inputClass"
        @input="onInput">
    </el-input>
</template>